import React, { createContext, useContext, useState, ReactNode } from 'react'

interface SideMenuContextType {
  isOpen: boolean
  toggleMenu: () => void
  closeMenu: () => void
}

const SideMenuContext = createContext<SideMenuContextType | undefined>(undefined)

export const SideMenuProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => setIsOpen(!isOpen)
  const closeMenu = () => setIsOpen(false)

  return (
    <SideMenuContext.Provider value={{ isOpen, toggleMenu, closeMenu }}>
      {children}
    </SideMenuContext.Provider>
  )
}

export const useSideMenu = () => {
  const context = useContext(SideMenuContext)
  if (context === undefined) {
    throw new Error('useSideMenu must be used within a SideMenuProvider')
  }
  return context
}